// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../node_modules/css-loader/dist/cjs.js??ref--7-oneOf-1-1!../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../node_modules/postcss-loader/src/index.js??ref--7-oneOf-1-2!../node_modules/postcss-loader/src/index.js??ref--7-oneOf-1-3!./styles/style.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "#App{position:absolute;width:100vw;height:100vh}*{box-sizing:border-box}.fade-enter-active,.fade-leave-active{transition-duration:.2s;transition-property:opacity;transition-timing-function:ease}.fade-enter,.fade-leave-active{opacity:0}.Kanit{font-family:Kanit,sans-serif!important}", ""]);
// Exports
module.exports = exports;
